/* Vitals reconciles first. A stable, expired promotional line can be removed
 * by its freshly verified exact key after the grace period. Never by variant ID. */
(() => {
  if (window.alpineVitalsCartMounted) return;
  window.alpineVitalsCartMounted = true;
  let giftSignature = null, positionTimer, giftCandidates = [], emptySince = 0, recoveryTimer;
  let root = null, active = null, amount = null, timer, busy = false, queued = false, pending = null, quantityPending = false, giftPending = false, giftPolls = 0;
  document.addEventListener('click', event => {
    const gift=event.target.closest('.vtl-ub-gift-root');
    if(gift && document.querySelector('#CartPageForm') && !document.querySelector('#CartDrawer.drawer--is-open')){
      document.documentElement.dataset.alpineGiftCartPageUntil=String(Date.now()+10000);
    }else if(event.target.closest('.js-drawer-open-cart,form[action*="/cart/add"]')){
      delete document.documentElement.dataset.alpineGiftCartPageUntil;
    }
  },true);
  // Vitals renders option lists in a dialog portal outside the drawer.
  // Let option/document handlers run, but do not bubble into outside-close.
  document.addEventListener('click', event => {
    const portal = (event.composedPath?.() || []).some(node =>
      node?.classList?.contains('Vtl-Dropdown__Portal-List'));
    if (portal && document.querySelector('#CartDrawer.drawer--is-open [data-alpine-vitals-cart] .vtl-ub-gift-root')) {
      event.stopPropagation();
    }
  });
  const mounts = () => Array.from(document.querySelectorAll('[data-alpine-vitals-cart]'));
  const money = n => 'NT$' + (n / 100).toLocaleString('zh-TW', {maximumFractionDigits: 2});
  const isAlpine = node => {
    const links = Array.from(node.querySelectorAll('.vtl-ub-gift__product__title'));
    return links.length && links.every(a => /毛帽頭套|Fingerless|開指|磁吸雪鏡|Ski Goggles/.test(a.textContent));
  };
  function position() {
    const list = mounts();
    const drawer = document.querySelector('#CartDrawer.drawer--is-open');
    const target = (drawer && list.find(m => drawer.contains(m))) || list.find(m => m.closest('#CartPageForm'));
    // Vitals can replace its root while reconciling gifts. Never resurrect
    // a detached React container or let an obsolete empty root win selection.
    document.querySelectorAll('.vtl-ub-gift-root').forEach(node => {
      if (!node.childNodes.length) node.remove();
    });
    const found = Array.from(document.querySelectorAll('.vtl-ub-gift-root')).find(isAlpine);
    root = found || (root?.isConnected ? root : null);
    if (!target || amount === null || amount <= 0) {
      list.forEach(m => { m.hidden = true; });
      if (root?.closest('[data-alpine-vitals-cart]')) document.body.append(root);
      return;
    }
    active = target;
    list.forEach(m => { m.hidden = m !== target; });
    const mount = target.querySelector('[data-alpine-vitals-mount]');
    if (root && root.parentElement !== mount) mount.append(root);
    const egReminders = document.querySelector('#aca-reminder-banners-wrapper');
    if (target.dataset.giftEngine === 'easygift' && egReminders) {
      // Keep app-owned reminder nodes outside the theme's rebuilt cart body.
      // Their existing listeners survive quantity updates and drawer rebuilds.
      let egHost = drawer?.querySelector('.drawer__fixed-header');
      if (!egHost) {
        const cartForm = document.querySelector('#CartPageForm');
        if (cartForm) {
          egHost = document.querySelector('[data-alpine-eg-reminders]');
          if (!egHost) {
            egHost = document.createElement('div');
            egHost.dataset.alpineEgReminders = '';
            cartForm.before(egHost);
          }
        }
      }
      if (egHost && egReminders.parentElement !== egHost) egHost.append(egReminders);
      egReminders.style.cssText = 'position:static!important;width:100%!important;max-width:none!important;transform:none!important;margin:8px 0!important;display:flex!important;flex-direction:column!important;gap:8px!important';
    }
    target.id = target.closest('#CartPageForm') ? 'alpine-gifts' : 'alpine-gifts-drawer';
    const available = amount >= 3500000 ? 3 : amount >= 2000000 ? 1 : 0;
    const claimed = giftCandidates.filter(g => g.final_line_price === 0 && amount >= g.threshold).length;
    const empty = !root?.querySelector('.vtl-ub-gift__product__title');
    // Vitals removes its widget children when all gifts are claimed, while
    // retaining the React root. Retire only an empty container so the next
    // native cart reconciliation mounts into a fresh root in this same slot.
    target.querySelector('[data-alpine-gift-recovery]')?.remove();
    // Open through Vitals so its focus/inert state remains authoritative.
    const trigger = root?.querySelector('.vtl-ub-gift__trigger');
    if (trigger?.getAttribute('aria-expanded') === 'false') trigger.click();
    const status = amount < 2000000 ? '再消費 ' + money(2000000 - amount) + '，解鎖可翻式毛帽頭套。'
      : amount < 3500000 ? '毛帽頭套已解鎖；再消費 ' + money(3500000 - amount) + '，再享手套與雪鏡。'
      : '毛帽頭套、手套與雪鏡，已全部解鎖。';
    const text = target.querySelector('[data-alpine-gift-status]');
    if (text.textContent !== status) text.textContent = status;
    const fill = Math.min(100, amount / 3500000 * 100) + '%';
    const bar = target.querySelector('[data-alpine-gift-fill]');
    if (bar.style.width !== fill) bar.style.width = fill;
    target.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.min(35000, amount / 100));
    root?.querySelectorAll('.vtl-ub-gift__tier').forEach(t => {
      const title = t.querySelector('.vtl-ub-gift__product__title')?.textContent || '';
      t.dataset.alpineThreshold = /毛帽頭套/.test(title) ? 'NT$20,000' : 'NT$35,000';
      const below = amount < (/毛帽頭套/.test(title) ? 2000000 : 3500000);
      const cta = t.querySelector('[data-vtl-el="cta"]');
      const nativeStatus = t.querySelector('[data-vtl-el="status"]');
      if (nativeStatus) nativeStatus.hidden = below;
      if (cta && below) { cta.disabled = true; cta.dataset.alpineLocked = 'true'; }
      else if (cta?.dataset.alpineLocked) { cta.disabled = false; delete cta.dataset.alpineLocked; }

    });
  }
  async function removeStaleGift(target, previous) {
    if (quantityPending) return false;
    const fresh = await fetch(target.dataset.ledgerUrl, {credentials:'same-origin',cache:'no-store'}).then(r => r.json());
    if (fresh.currency !== 'TWD' || !Number.isSafeInteger(fresh.eligible_subtotal) || fresh.eligible_subtotal !== previous.eligible_subtotal) return false;
    const stale = (fresh.gift_candidates || []).find(g => Number.isSafeInteger(g.threshold) && fresh.eligible_subtotal < g.threshold && previous.gift_candidates?.some(p => p.key === g.key && p.threshold === g.threshold));
    if (!stale) return false;
    const cart = await fetch('/cart.js', {credentials:'same-origin',cache:'no-store'}).then(r => r.json());
    const line = cart.items?.find(item => item.key === stale.key);
    const offer = String(line?.properties?._oid || '').split('_')[0];
    const expected = offer === '1233222' && line?.product_id === 8795183448260 ? 2000000
      : offer === '1233222' && line?.product_id === 8729402441924 ? 3500000
      : offer === '1233237' && line?.variant_id === 47007140872388 ? 3500000 : 0;
    if (!expected || expected !== stale.threshold || quantityPending) return false;
    const response = await fetch('/cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
    if (!response.ok) return false; // An expired key must never fall back to an ID.
    const updated = await response.json();
    if (!Array.isArray(updated.items) || updated.items.some(item => item.key === line.key)) return false;
    document.querySelectorAll('#CartPageForm .cart__item[data-key],#CartDrawerForm .cart__item[data-key]').forEach(node => {
      if (node.dataset.key === line.key) node.remove();
    });
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:updated}}));
    document.dispatchEvent(new CustomEvent('cart:build'));
    return true;
  }
  // EG discounts enforce eligibility at checkout. Remove only its exact marked
  // promotional line before checkout; never a paid item sharing the same variant.
  async function reconcileEg(target) {
    for (let attempt = 0; attempt < 3; attempt++) {
      const ledger = await fetch(target.dataset.ledgerUrl, {credentials:'same-origin',cache:'no-store'}).then(r => r.json());
      if (ledger.currency !== 'TWD' || !Number.isSafeInteger(ledger.gross_subtotal)) return;
      const stale = (ledger.eg_gifts || []).find(g => ledger.gross_subtotal < g.threshold);
      if (!stale || quantityPending) return;
      const cart = await fetch('/cart.js', {credentials:'same-origin',cache:'no-store'}).then(r => r.json());
      const line = cart.items?.find(item => item.key === stale.key && item.properties?._Gifted === stale.rule);
      if (!line || quantityPending) return;
      const response = await fetch('/cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
      if (!response.ok) return;
      const updated = await response.json();
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:updated}}));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }
  async function refresh() {
    if (busy) { queued = true; return pending; }
    const target = mounts()[0];
    if (!target) return;
    busy = true;
    try {
      await reconcileEg(target);
      const response = await fetch(target.dataset.ledgerUrl, {credentials:'same-origin',cache:'no-store'});
      const ledger = await response.json();
      giftCandidates = ledger.gift_candidates || [];
      const basis = target.dataset.giftEngine === 'easygift' ? ledger.gross_subtotal : ledger.eligible_subtotal;
      amount = ledger.currency === 'TWD' && Number.isSafeInteger(basis) ? basis : null;
      const nextGiftSignature = JSON.stringify((ledger.gift_candidates || []).map(g => [g.key, g.final_line_price]).sort());
      const giftsChanged = giftSignature !== null && giftSignature !== nextGiftSignature;
      giftSignature = nextGiftSignature;
      // Refresh native line markup once when gift lines actually change.
      if (giftsChanged) document.dispatchEvent(new CustomEvent('cart:build')); 
      if (amount !== null) {
        const invalid = (ledger.gift_candidates || []).filter(g => Number.isSafeInteger(g.threshold) && amount < g.threshold);
        // Give Vitals a chance to reconcile first. Some PDPs do not load its
        // widget. Never send expired keys to update.js or fall back to variant IDs.
        if (invalid.length) {
          giftPending = true;
          ++giftPolls;
          // Allow Vitals 15 seconds first. Re-read both eligibility and the
          // exact promotional key before a single fallback removal.
          if (giftPolls > 20 && !quantityPending) {
            const removed = await removeStaleGift(target, ledger);
            giftPolls = removed ? 20 : 0;
          }
          if (giftPolls <= 20) {
            clearTimeout(timer);
            timer = setTimeout(() => { pending = refresh(); }, 750);
          }
        } else {
          giftPolls = 0;
          if (giftPending) {
            giftPending = false;
            // The changed gift signature above already schedules one rebuild.
          }
        }
      }
      position();
    } catch (_) { amount = null; position(); }
    finally { busy = false; if (queued) { queued = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(() => { pending = refresh(); }, 350); }
  new MutationObserver(records => {
    if (records.some(r => r.type === 'childList')) {
      clearTimeout(positionTimer);
      positionTimer = setTimeout(position, 80);
    }
  }).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('cart:updated', () => { quantityPending = false; });
  document.addEventListener('click', e => { if (e.target.closest('.js-qty__adjust')) quantityPending = true; }, true);
  let typedQuantityPending = false;
  // Motion/Vitals can rebuild quantity controls without restoring the input
  // change listener. Own typed changes once, using only the current line key.
  document.addEventListener('change', async e => {
    const input = e.target;
    if (!input.matches('.js-qty__num')) return;
    const form = input.closest('#CartDrawerForm,#CartPageForm');
    if (!form || !input.dataset.id) return;
    e.stopImmediatePropagation();
    const qty = Number(input.value);
    if (input.value.trim() === '' || !Number.isSafeInteger(qty) || qty < 0 || typedQuantityPending) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      return;
    }
    typedQuantityPending = true; quantityPending = true;
    const controls = [...document.querySelectorAll('#CartDrawerForm .js-qty__num,#CartDrawerForm .js-qty__adjust,#CartPageForm .js-qty__num,#CartPageForm .js-qty__adjust')];
    const enabled = controls.filter(node => !node.disabled);
    enabled.forEach(node => { node.disabled = true; });
    try {
      const response = await fetch('/cart/change.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:input.dataset.id, quantity:qty})});
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error('Quantity update failed');
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
    } catch (_) {
      const status = form.querySelector('[data-alpine-gift-status]');
      if (status) status.textContent = '數量尚未更新，請再試一次。';
    } finally {
      typedQuantityPending = false; quantityPending = false;
      enabled.forEach(node => { node.disabled = false; });
      document.dispatchEvent(new CustomEvent('cart:build'));
      schedule();
    }
  }, true);

  ['cart:updated','cart:build','ajaxProduct:added','drawerOpen'].forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('click', e => {
    if (e.target.closest('.js-qty__adjust,.vtl-ub-gift-root,.js-drawer-open-cart,.js-drawer-close')) {
      schedule(); setTimeout(() => { pending = refresh(); }, 1200); setTimeout(() => { pending = refresh(); }, 2500);
    }
  });
  document.addEventListener('change', e => { if (e.target.closest('#CartDrawerForm,#CartPageForm')) schedule(); });
  // A user can type a quantity and immediately submit before blur/change.
  // Commit those edits before checking gift eligibility; never let the native
  // form post an older positional updates[] array after gift removal.
  async function commitCheckoutQuantities(form) {
    const edits = [...form.querySelectorAll('.js-qty__num[data-id]')]
      .filter(input => input.value !== input.defaultValue)
      .map(input => ({key:input.dataset.id, value:input.value.trim()}));
    for (const edit of edits) {
      const qty = Number(edit.value);
      if (!edit.value || !Number.isSafeInteger(qty) || qty < 0) throw Error('Invalid quantity');
      const cart = await fetch('/cart.js', {credentials:'same-origin',cache:'no-store'}).then(r=>r.json());
      const line = cart.items?.find(item=>item.key===edit.key);
      if (!line) throw Error('Cart line changed; retry with refreshed cart');
      if (line.quantity === qty) continue;
      const response = await fetch('/cart/change.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:qty})});
      const updated = await response.json();
      if (!response.ok || !Array.isArray(updated.items)) throw Error('Quantity update failed');
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:updated}}));
    }
  }
  let checkoutChecked = false;
  document.addEventListener('submit', async e => {
    if (checkoutChecked || !e.target.matches('#CartDrawerForm,#CartPageForm')) return;
    const button = e.submitter;
    if (!button || button.name !== 'checkout') return;
    e.preventDefault(); e.stopImmediatePropagation();
    button.disabled = true;
    try {
      if (quantityPending) throw new Error('Quantity update pending');
      await commitCheckoutQuantities(e.target);
      if (pending) await pending;
      await refresh();
      // Re-read after removals; never submit a cart with a charged promotional gift.
      const response = await fetch(mounts()[0].dataset.ledgerUrl, {credentials:'same-origin',cache:'no-store'});
      const ledger = await response.json();
      if ((ledger.eg_gifts || []).some(g => ledger.currency !== 'TWD' || ledger.gross_subtotal < g.threshold || g.final_line_price > 0)) throw new Error('EG gift reconciliation pending');
      if ((ledger.gift_candidates || []).length && (ledger.currency !== 'TWD' || !Number.isSafeInteger(ledger.eligible_subtotal) || ledger.gift_candidates.some(g => ledger.eligible_subtotal < g.threshold || g.final_line_price > 0))) throw new Error('Please retry');
      const liveForm = document.getElementById(e.target.id) || e.target;
      const liveButton = liveForm.querySelector('[name="checkout"]') || button;
      // The cart has already been committed and reconciled above. Posting stale
      // quantity arrays could re-add or turn a removed gift into a paid item.
      liveForm.querySelectorAll('[name="updates[]"]').forEach(input=>{input.disabled=true;});
      checkoutChecked = true;
      liveButton.disabled = false;
      liveForm.requestSubmit(liveButton);
    } catch (_) {
      const status = document.querySelector('[data-alpine-gift-status]');
      if (status) status.textContent = '購物車優惠更新中，請稍後再結帳。';
      button.disabled = false;
    }
  }, true);
  let egEventsBound = false, egRetry = 0, egBuildTimer;
  function bindEgEvents() {
    if (egEventsBound) return;
    if (!window.EasyGift?.Events?.subscribe) {
      if (++egRetry < 30) setTimeout(bindEgEvents, 500);
      return;
    }
    egEventsBound = true;
    window.EasyGift.Events.subscribe('afterCartRequest', data => {
      if (String(data?.method).toUpperCase() !== 'POST') return;
      clearTimeout(egBuildTimer);
      egBuildTimer = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:build'));
        schedule();
      }, 450);
    });
  }
  bindEgEvents();
  pending = refresh();
})();






// Alpine choices are optional cart actions. Let EG resolve its automatic
// selection prompt as 'later'; do not hold the customer's add-to-cart request.
(() => {
  if (window.alpineOptionalGiftsMounted) return;
  window.alpineOptionalGiftsMounted = true;
  let mutating = false, renderTimer, lastLedger, selections = new Map(), reopenDrawer = false, reopenTimer;
  document.addEventListener('click', event => {
    if(event.target.closest('#CartDrawer .js-qty__adjust,#CartDrawer [data-alpine-gift-claim]')) reopenDrawer = true;
    if(event.target.closest('.js-drawer-close')) reopenDrawer = false;
  },true);
  const cards = () => [...document.querySelectorAll('[data-alpine-gift-card]')];
  const ledgerUrl = () => document.querySelector('[data-alpine-vitals-cart]')?.dataset.ledgerUrl;
  const readLedger = () => fetch(ledgerUrl(),{credentials:'same-origin',cache:'no-store'}).then(r=>r.json());
  function releaseChoice() {
    document.querySelectorAll('#aca-modal-container[open]').forEach(dialog => {
      if (!/Alpine/i.test(dialog.textContent) || !/毛帽頭套|手套|雪鏡/.test(dialog.textContent)) return;
      const close = dialog.querySelector('#aca-bottom-close');
      if (close && !dialog.dataset.alpineDeferred) {
        dialog.dataset.alpineDeferred = 'true';
        // Use the app's dismissal handler, including its request resolution.
        close.addEventListener('click', event => event.stopPropagation(), {once:true});
        close.click();
        if(reopenDrawer && !document.querySelector('#CartPageForm')) {
          clearTimeout(reopenTimer);
          reopenTimer=setTimeout(()=>document.dispatchEvent(new CustomEvent('cart:open')),250);
        }
      }
    });
    document.querySelectorAll('[easygift-reminder-banner-rule]').forEach(node => {
      if (['6adcc5666151551713b46c5e','6adcc64f65e671ca248766cb','6adcd18ea77589a526d96359'].includes(node.getAttribute('easygift-reminder-banner-rule'))) node.hidden = true;
    });
  }
  function paint(ledger) {
    if (!ledger || ledger.currency !== 'TWD' || !Number.isSafeInteger(ledger.gross_subtotal)) return;
    lastLedger = ledger;
    cards().forEach(card => {
      const unlocked = ledger.gross_subtotal >= Number(card.dataset.threshold);
      const selected = (ledger.eg_gifts || []).find(g=>g.rule===card.dataset.rule);
      const state = !unlocked ? 'locked' : selected?.final_line_price === 0 ? 'claimed' : 'available';
      if(card.dataset.state !== state) card.dataset.state = state;
      const select = card.querySelector('select');
      const button = card.querySelector('[data-alpine-gift-claim]');
      const choice = selections.get(card.dataset.rule) || selected?.key?.split(':')[0];
      if(choice && [...select.options].some(o=>o.value===choice)) select.value=choice;
      const photo = card.querySelector('img'), source=select.selectedOptions[0]?.dataset.image;
      if(photo && source && photo.getAttribute('src')!==source)photo.src=source;
      select.disabled = !unlocked || mutating;
      button.disabled = !unlocked || mutating || !select.value;
      const label = mutating ? '更新中…' : !unlocked ? '尚未解鎖' : selected ? '更換款式' : '領取贈品';
      if(button.textContent !== label)button.textContent = label;
      const status=card.querySelector('[data-alpine-gift-card-status]');
      const text=selected?.final_line_price===0?'已加入購物車':unlocked?'已解鎖・自由選擇':'消費滿 NT$'+(Number(card.dataset.threshold)/100).toLocaleString('zh-TW');
      if(status.textContent!==text)status.textContent=text;
    });
  }
  async function refreshCards(){try{paint(await readLedger());}catch(_){/* Keep shopping available on transient read failure. */}}
  function schedule(){clearTimeout(renderTimer);renderTimer=setTimeout(refreshCards,180);}
  new MutationObserver(()=>{releaseChoice();schedule();}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});
  ['cart:build','cart:updated','drawerOpen','ajaxProduct:added'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('change',event=>{
    const select=event.target.closest('[data-alpine-gift-card] select');if(!select)return;
    selections.set(select.closest('[data-alpine-gift-card]').dataset.rule,select.value);
    const image=select.closest('[data-alpine-gift-card]').querySelector('img');
    if(image && select.selectedOptions[0]?.dataset.image)image.src=select.selectedOptions[0].dataset.image;
  });
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-alpine-gift-claim]');if(!button)return;
    event.preventDefault();if(mutating)return;
    const card=button.closest('[data-alpine-gift-card]');
    const variant=card.querySelector('select').value, rule=card.dataset.rule;
    const feedback=card.closest('[data-alpine-vitals-cart]').querySelector('[data-alpine-claim-feedback]');
    mutating=true;paint(lastLedger);feedback.textContent='';
    try{
      const ledger=await readLedger();
      if(ledger.currency!=='TWD'||ledger.gross_subtotal<Number(card.dataset.threshold))throw Error('尚未達到領取門檻。');
      const existing=(ledger.eg_gifts||[]).find(g=>g.rule===rule);
      if(existing){
        const cart=await fetch('/cart.js',{cache:'no-store'}).then(r=>r.json());
        const line=cart.items.find(i=>i.key===existing.key&&i.properties?._Gifted===rule);
        if(line?.variant_id===Number(variant)){feedback.textContent='此款式已在購物車中。';return;}
        if(line){const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});if(!r.ok)throw Error('款式尚未更新，請再試一次。');}
      }
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,properties:{_Gifted:rule}}]})});
      if(!r.ok)throw Error('此款式暫時無法加入，請選擇其他款式。');
      await r.json();
      const updated=await readLedger();
      const added=(updated.eg_gifts||[]).find(g=>g.rule===rule);
      if(!added||added.final_line_price!==0)throw Error('贈品優惠確認中，請稍後再試。');
      feedback.textContent='贈品已加入。';
    }catch(error){feedback.textContent=error.message;}
    finally{mutating=false;document.dispatchEvent(new CustomEvent('cart:build'));schedule();}
  });
  releaseChoice();schedule();
})();

